import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { formatText } from '../../../helpers/value'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import classes from './index.module.scss'
import { Premium } from './Premium'
import { Standard } from './Standard'

export const Infor = ({ data, detailKey }) => {
  const userType = useSelector(selectUserType)

  const detailData = data[detailKey]

  const renderContent = () => {
    return userType && userType.userTypeId === USER_TYPE.PREMIUM ? (
      <Premium detailData={detailData} />
    ) : (
      <Standard />
    )
  }

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element className={classes.content} style={{ color: '#3A414B' }}>
        {renderContent()}
      </Element>
    </Panel>
  )
}
